import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@chakra-ui/react';
import { Gold } from '../../../context/Chakra/Icons';

const BlockTitle = ({ icon, title, showSkeleton }) => {
  return (
    <div className="member-center__block_title">
      <div className="member-center__block_title-icon">{icon || <Gold />}</div>
      {showSkeleton ? <Skeleton h="20px" w="137px" /> : <span>{title}</span>}
    </div>
  );
};

BlockTitle.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string.isRequired,
  showSkeleton: PropTypes.bool,
};

export default BlockTitle;
